import * as api from "app/api/selfExclusionApi";
import { SelfExclusionHelper } from "app/helpers/selfExclusionHelper";
import { LogoutHelper } from "app/screens/AccountScreen/screens/helpers/LogoutHelper/LogoutHelper";
import { MouseEvent, useEffect, useState } from "react";
import SelfExclusionForm from "./components/SelfExclusionForm/SelfExclusionForm";
import SelfExclusionMessage from "./components/SelfExclusionMessage/SelfExclusionMessage";
import "./SelfExclusion.scss";
//
const SelfExclusion = () => {
  const [disabled, setDisabled] = useState(true);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [hideForm, setHideForm] = useState(false);
  const [selfExclusionTimePeriod, setSelfExclusionTimePeriod] =
    useState("default");

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelfExclusionTimePeriod(e.target.value);
  };

  useEffect(() => {
    if (selfExclusionTimePeriod !== "default") {
      setDisabled(false);
    }
  }, [selfExclusionTimePeriod]);

  const handleSelfExclusionLogout = () => LogoutHelper.logout();

  const handleSubmit = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent<HTMLButtonElement>>
  ) => {
    e.preventDefault();
    setLoading(true);
    // send selfExclusionTimePeriod to the server
    api
      .setSelfExclusionPeriod(
        SelfExclusionHelper.calculateSelfExclusionTimePeriod(
          selfExclusionTimePeriod
        )
      )
      .then((resp: any) => {
        setLoading(false);
        // log out user and display self exclusion message on logout screen
        handleSelfExclusionLogout();
      })
      .catch((error: any) => {
        setLoading(false);
        setError(error.message);
      });
  };

  // Display a self-exclusion message to confirm the user's self-exclusion
  const handleDisplayConfirmationMessage = () => setHideForm(true);

  return (
    <div className="self-exclusion">
      <SelfExclusionForm
        hideForm={hideForm}
        handleSelectChange={handleSelectChange}
        error={error}
        disabled={disabled}
        handleDisplayConfirmationMessage={handleDisplayConfirmationMessage}
        selfExclusionTimePeriod={selfExclusionTimePeriod}
      />
      <SelfExclusionMessage
        hideForm={hideForm}
        loading={loading}
        handleConfirmSelfExclusion={handleSubmit}
        setHideForm={setHideForm}
      />
    </div>
  );
};

export default SelfExclusion;
